export interface Service {
  id: string
  number: string
  title: string
  description: string
  features: string[]
  technologies: string[]
}

export const services: Service[] = [
  {
    id: 'web-dev',
    number: '01',
    title: 'Conversion-Focused Website Development',
    description: 'We build high-performance, scalable websites that drive results. From custom corporate portals to complex web applications, our development team delivers pixel-perfect, responsive solutions using modern frameworks and best practices. Every website we create is optimized for speed, SEO, and conversion.',
    features: [
      'Custom Frontend Development (React, Vue, Next.js)',
      'Backend Systems (Node.js, Laravel, Python)',
      'Responsive & Mobile-First Design',
      'Performance Optimization (90+ PageSpeed)',
      'SEO-Ready Architecture',
      'CMS Integration (WordPress, Strapi, Sanity)',
    ],
    technologies: ['React', 'Next.js', 'Laravel', 'Node.js', 'WordPress', 'Strapi'],
  },
  {
    id: 'branding',
    number: '02',
    title: 'Branding & Design',
    description: 'Your brand is more than a logo — it is the complete experience your customers have with your business. We create cohesive brand identities that communicate your values, differentiate you from competitors, and build lasting emotional connections with your audience.',
    features: [
      'Brand Strategy & Positioning',
      'Logo Design & Visual Identity',
      'Brand Guidelines & Style Guides',
      'UI/UX Design for Web & Mobile',
      'Marketing Collateral Design',
      'Brand Refresh & Redesign',
    ],
    technologies: ['Figma', 'Adobe Creative Suite', 'Sketch', 'Principle', 'After Effects'],
  },
  {
    id: 'crm',
    number: '03',
    title: 'Custom CRM Systems & Integrations',
    description: 'Streamline your customer relationships with a custom CRM built specifically for your business workflows. We design and develop CRM solutions that centralize your customer data, automate repetitive tasks, and give your team the insights they need to close more deals and retain customers longer.',
    features: [
      'Custom CRM Development',
      'Sales Pipeline Management',
      'Customer Data Centralization',
      'Marketing Automation Integration',
      'Reporting & Analytics Dashboards',
      'Third-Party Integrations (HubSpot, Salesforce, Zoho)',
    ],
    technologies: ['Laravel', 'React', 'PostgreSQL', 'Redis', 'AWS', 'REST APIs'],
  },
  {
    id: 'ecommerce',
    number: '04',
    title: 'E-Commerce',
    description: 'Launch and scale your online store with a powerful e-commerce platform designed for conversions. We build secure, feature-rich shopping experiences with seamless payment integration, inventory management, and analytics that help you understand your customers and grow your revenue.',
    features: [
      'Custom Online Store Development',
      'Shopify & WooCommerce Customization',
      'Payment Gateway Integration (Stripe, PayPal, Square)',
      'Inventory & Order Management',
      'Multi-Vendor Marketplace Solutions',
      'Conversion Rate Optimization',
    ],
    technologies: ['Shopify', 'WooCommerce', 'Stripe', 'React', 'Node.js', 'PostgreSQL'],
  },
  {
    id: 'landing',
    number: '05',
    title: 'Landing Pages',
    description: 'High-converting landing pages engineered for a single goal — action. Whether you are driving traffic from ads, email campaigns, or social media, we design and develop landing pages that capture attention, communicate value, and convert visitors into leads and customers.',
    features: [
      'Conversion-Focused Design',
      'A/B Testing Ready Architecture',
      'Fast Load Times (Under 2 Seconds)',
      'Lead Capture Form Integration',
      'Analytics & Tracking Setup',
      'Mobile-Optimized Experience',
    ],
    technologies: ['Next.js', 'React', 'Vercel', 'Google Analytics', 'Hotjar'],
  },
  {
    id: 'saas',
    number: '06',
    title: 'SaaS Product Development',
    description: 'Turn your software idea into a fully-functional SaaS product. We handle everything from architecture design and MVP development to multi-tenant infrastructure, subscription billing, and user management. Launch faster and scale confidently with a platform built for growth.',
    features: [
      'MVP & Full-Product Development',
      'Multi-Tenant Architecture',
      'Subscription & Billing Management',
      'User Authentication & Roles',
      'API Development & Documentation',
      'Cloud Infrastructure (AWS, GCP, Azure)',
    ],
    technologies: ['React', 'Node.js', 'PostgreSQL', 'Docker', 'AWS', 'Stripe Billing'],
  },
  {
    id: 'ai',
    number: '07',
    title: 'AI Agents, Chatbots & Automation',
    description: 'Harness the power of artificial intelligence to automate workflows, enhance customer support, and gain competitive advantage. We build intelligent chatbots, AI-powered automations, and custom AI integrations that save time, reduce costs, and deliver exceptional user experiences 24/7.',
    features: [
      'AI Chatbots for Website, WhatsApp & Internal Teams',
      'Voice, Chat & Workflow Automation with AI Agents',
      'OpenAI / GPT Integration',
      'Natural Language Processing Solutions',
      'AI-Powered Content Generation',
      'CRM Connectivity, Human Handoff & Monitoring',
    ],
    technologies: ['OpenAI API', 'LangChain', 'Python', 'Node.js', 'TensorFlow', 'Twilio'],
  },
  {
    id: 'seo',
    number: '08',
    title: 'SEO & Paid Growth',
    description: 'Rank higher, get found, and grow your revenue with data-driven SEO and digital marketing. We combine technical optimization, content strategy, and authority building to put your business in front of the right audience at the right moment — turning search traffic into measurable growth.',
    features: [
      'Technical SEO Audits & Fixes',
      'On-Page & Off-Page Optimization',
      'Keyword Research & Strategy',
      'Content Strategy & Creation',
      'Google Ads, Local SEO & Landing Pages',
      'Analytics, Tracking & Monthly Reporting',
    ],
    technologies: ['Google Search Console', 'Google Analytics 4', 'SEMrush', 'Ahrefs', 'Schema.org', 'PageSpeed Insights'],
  },
]

export const additionalServices = [
  'Website Maintenance & Support',
  'Legacy System Modernization',
  'API Development & Integration',
  'Cloud Migration Services',
  'Performance Auditing',
  'Technical Consulting',
]
